import React from 'react';
import RowHead from '@firsttable/web-components/molecules/RowHead';
import styled from 'styled-components';
import { breakpointsObject as bp } from '@firsttable/web-theme';
import media from 'styled-media-query';
import Box from '@firsttable/web-components/atoms/Box/Box';
import PageLoading from '../molecules/PageLoading';

const StyledContainerContent = styled.div`
  min-height: calc(100vh - 84px);
  display: grid;
  place-items: center;

  @supports (height: 100dvh) {
    min-height: calc(100dvh - 84px);
  }

  ${media.lessThan(bp.s)`
    min-height: calc(100vh - 52px);

    @supports (height: 100dvh) {
      min-height: calc(100dvh - 52px);
    }
  `}
`;

interface LoadingLayoutProps {
  title?: string;
  subTitle?: string;
}

const LoadingLayout = ({ title, subTitle }: LoadingLayoutProps) => (
  <>
    <StyledContainerContent>
      {(title || subTitle) && <RowHead title={title} subTitle={subTitle} />}
      <PageLoading />
      <Box />
    </StyledContainerContent>
  </>
);

export default LoadingLayout;
